import Swiper from "swiper/bundle";
import AOS from "aos";
import moment from "moment";
// import styles bundle
import "swiper/css/bundle";

require("moment-timezone");

jQuery(document).ready(function ($) {
    $(".datepicker").datepicker({
        beforeShow: function (input, inst) {
            $("#ui-datepicker-div").addClass("exceptions-datepicker");
        },
        dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        dateFormat: "dd/mm/yy",
        changeMonth: true,
        changeYear: true,
        yearRange: "-00:+03", // Adjust date format as needed
    });

    //aos settings global
    AOS.init({
        duration: 1200, // values from 0 to 3000, with step 50ms
        easing: "ease",
        offset: 150,
        // disable: 'mobile',
        disable: function () {
            var maxWidth = 1160;
            return window.innerWidth < maxWidth;
        },
    });

    //csv creation
    $("#download-csv-btn").on("click", function (e) {
        e.preventDefault();

        var reference = $(this).data("reference");
        var button = $(this);
        var originalText = button.text();

        // Disable button and show loading state
        button.prop("disabled", true).text("Generating CSV...");

        // Create a form and submit it
        var form = $("<form>", {
            method: "POST",
            action: site_data.adminajax,
        });

        form.append(
            $("<input>", {
                type: "hidden",
                name: "action",
                value: "download_survey_csv",
            }),
        );

        form.append(
            $("<input>", {
                type: "hidden",
                name: "reference",
                value: reference,
            }),
        );

        $("body").append(form);
        form.submit();
        form.remove();

        // Re-enable button after a delay
        setTimeout(function () {
            button.prop("disabled", false).text(originalText);
        }, 1000);
    });

    // SWIPER SLIDERS

    //quotes carousel
    const quotes = document.querySelectorAll(".quotes-wrapper");
    var i = 0;

    for (i = 0; i < quotes.length; i++) {
        var first = quotes[i].nextElementSibling;

        quotes[i].classList.add("quotes-wrapper-" + i); //slider
        first.classList.add("quotes-pagination-" + i); //pagination

        var quotesSlides = new Swiper(".quotes-wrapper-" + i, {
            speed: 1000,
            direction: "horizontal",
            effect: "fade",
            allowTouchMove: false,
            fadeEffect: {
                crossFade: true,
            },
            autoplay: true,
            loop: true,
            slidesPerView: 1,
            pagination: {
                el: ".quotes-pagination-" + i,
                type: "bullets",
                clickable: true,
            },
        });
    }

    const wonderings = document.querySelectorAll(".wonderings-wrapper");
    var i = 0;

    for (i = 0; i < wonderings.length; i++) {
        var first = wonderings[i].nextElementSibling.firstElementChild.firstElementChild;
        var second = first.nextElementSibling;

        wonderings[i].classList.add("wonderings-wrapper-" + i); //slider
        second.classList.add("wonderings-swiper-button-next-" + i); //next
        first.classList.add("wonderings-swiper-button-prev-" + i); //previous

        var wonderingsSlides = new Swiper(".wonderings-wrapper-" + i, {
            speed: 1000,
            direction: "horizontal",
            allowTouchMove: true,
            autoplay: false,
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".wonderings-swiper-button-next-" + i,
                prevEl: ".wonderings-swiper-button-prev-" + i,
            },
            on: {
                init: function () {
                    updateSlideCounter(this);
                },
                slideChange: function () {
                    updateSlideCounter(this);
                },
            },
        });
    }

    const reflective = document.querySelectorAll(".reflective-wrapper");
    var i = 0;

    for (i = 0; i < reflective.length; i++) {
        var first = reflective[i].nextElementSibling.firstElementChild.firstElementChild;
        var second = first.nextElementSibling;

        reflective[i].classList.add("reflective-wrapper-" + i);
        second.classList.add("reflective-swiper-button-next-" + i);
        first.classList.add("reflective-swiper-button-prev-" + i);

        // Find the counter inside THIS swiper block
        const counter = reflective[i].parentElement.querySelector(".reflective-slide-counter");

        window.console.log(reflective[i].parentElement);

        var reflectiveSlides = new Swiper(".reflective-wrapper-" + i, {
            speed: 1000,
            direction: "horizontal",
            allowTouchMove: true,
            autoplay: false,
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".reflective-swiper-button-next-" + i,
                prevEl: ".reflective-swiper-button-prev-" + i,
            },
            on: {
                init: function () {
                    updateSlideCounter1(this, counter);
                },
                slideChange: function () {
                    updateSlideCounter1(this, counter);
                },
            },
        });
    }

    function updateSlideCounter1(swiperInstance, counterEl) {
        const current = swiperInstance.realIndex + 1;
        const total = swiperInstance.slides.length - swiperInstance.loopedSlides * 2 || swiperInstance.slides.length;

        if (counterEl) {
            counterEl.textContent = `${current} / ${total}`;
        }
    }

    function updateSlideCounter(swiperInstance) {
        const current = swiperInstance.realIndex + 1;
        const total = swiperInstance.slides.length - swiperInstance.loopedSlides * 2 || swiperInstance.slides.length;
        document.getElementById("wonderings-slide-counter").textContent = `${current} / ${total}`;
    }

    //denomination prompt select
    $("body").on("change", "#field_denomination", function () {
        var denomination = $(this).val();

        if (denomination == "Other") {
            $("#field_denomination_2").removeClass("d-none");
        } else {
            $("#field_denomination_2").addClass("d-none");
            $("#field_denomination_2").val("");
        }

        if (denomination == "Church of England") {
            $("#coe_partnership_wrapper").removeClass("d-none");
        } else {
            $("#coe_partnership_wrapper").addClass("d-none");
            $("#coe_questions_wrapper").addClass("d-none");
            $("#field_coe_partnership_yes, #field_coe_partnership_no").prop("checked", false);
            $("#field_parish_id").val("");
            $("#field_agree_survey_tool").prop("checked", false);
            $("#field_agree_run_course").prop("checked", false);
        }
    });

    $("body").on("change", "input[name='coe_partnership']", function () {
        if ($(this).val() == "Yes") {
            $("#coe_questions_wrapper").removeClass("d-none");
        } else {
            $("#coe_questions_wrapper").addClass("d-none");
            $("#field_parish_id").val("");
            $("#field_agree_survey_tool").prop("checked", false);
            $("#field_agree_run_course").prop("checked", false);
        }
    });

    $("body").on("submit", "#additionalInfo", function (event) {
        var lat = $("#field_latitude").val();
        var lng = $("#field_longitude").val();

        // Check if they are not empty
        if ($("#field_autocomplete").length && lat == "" && lng == "") {
            event.preventDefault();
            $("#errors_additionalInfo").text("Please enter a town or city and select from the available options.");
        }

        if ($("#coe_partnership_wrapper").length && !$("#coe_partnership_wrapper").hasClass("d-none")) {
            var coePartnership = $("input[name='coe_partnership']:checked").val();

            if (!coePartnership) {
                event.preventDefault();
                $("#errors_coe_partnership").text("Please select an option.");
            }
        }

        if ($("#coe_questions_wrapper").length && !$("#coe_questions_wrapper").hasClass("d-none")) {
            var parishId = $("#field_parish_id").val();
            var agreeSurveyTool = $("#field_agree_survey_tool").is(":checked");
            var agreeRunCourse = $("#field_agree_run_course").is(":checked");

            if (!/^\d{6}$/.test(parishId)) {
                event.preventDefault();
                $("#errors_coe_questions").text("Please enter a valid 6 digit parish identification code.");
            } else if (!agreeSurveyTool || !agreeRunCourse) {
                event.preventDefault();
                $("#errors_coe_questions").text("Please agree to both statements to continue.");
            }
        }
    });

    // FORMIDABLE
    var trainingTypeSelector = 'input[id^="field_host-training-training-type-"]';
    var seatsSelector = "#field_we5hy"; // Number of seats

    function applyCoeDiscount() {
        var $checked = $(trainingTypeSelector + ":checked");

        if (!$checked.length) {
            return;
        }

        if (!site_data.coe_discount_eligible) {
            $("#field_coediscount").val(0).trigger("change");
            return;
        }

        var discount;
        if ($checked.val() === "50") {
            var seats = parseInt($(seatsSelector).val(), 10);
            discount = seats === 1 ? 60 : 110;
        } else {
            discount = 0;
        }

        $("#field_coediscount").val(discount).trigger("change");
    }

    $("body").on("click", trainingTypeSelector, applyCoeDiscount);
    $("body").on("change", seatsSelector, applyCoeDiscount);
    applyCoeDiscount();

    //menu
    $("body").on("click", ".mobileMenu .contain", function () {
        $(".menu .content").show();
        $("#page").toggleClass("mobileOpen");
        $(".menu .content").toggleClass("open");
        $(".menuContainer").toggleClass("active");
        $(".menuContainer .menu").toggleClass("show");

        $("body").toggleClass("hidden");

        if ($("#page").hasClass("mobileOpen")) {
            $("#Line_971").css("stroke", "#001121");
            $(".ellipseHide").hide();
            $("#animatedlogo").css("z-index", "999");
            $("#footer").css("z-index", "0");
        } else {
            $("#Line_971").css("stroke", "#fff");
            $(".ellipseHide").show();
            $("#animatedlogo").css("z-index", "5");
            $("#footer").css("z-index", "101");
        }

        $(".logo svg").toggleClass("openNav");
        $("#animatedLogoSVGText").toggleClass("openNav");

        $(this).parent().toggleClass("open");
    });

    if ($(".whiteOverlay").length) {
        var scrolltop = $(window).scrollTop();
        var distance = $("#animateSpace").offset().top;
        var height = $("#animateSpace").height();

        var triggerPoint = distance + height;

        if (scrolltop >= triggerPoint) {
            $(".whiteOverlay").addClass("fixed");
        } else {
            $(".whiteOverlay").removeClass("fixed");
        }
    }

    if ($(".whiteOverlayPage").length) {
        var scrolltop = $(window).scrollTop();
        var triggerPoint = $("#animateSpacePage").height();

        if (scrolltop >= triggerPoint) {
            $(".whiteOverlayPage").addClass("fixed");
        } else {
            $(".whiteOverlayPage").removeClass("fixed");
        }
    }

    if ($(window).scrollTop() != 0) {
        $("#animatedLogoSVG:not(.constantAnimated)").addClass("animated");
        $("#animatedLogoSVGText:not(.constantAnimated)").addClass("animated");
        $(".desktopNav").not(".noanimate").addClass("up");
        $("#nav-icon").not(".noanimate").addClass("up");
        $("#homeLogo").addClass("move");
        $("#svgtextgroup").css("transform", "translate(1px, 0px)");
        $("#svgtextgroup").css("transition", "0s");
    } else {
        $("#animatedLogoSVG:not(.constantAnimated)").addClass("transition");
        $("#animatedLogoSVGText:not(.constantAnimated)").addClass("transition");
        $("#nav-icon").not(".noanimate").addClass("transition");
        $(".desktopNav").not(".noanimate").addClass("transition");
        $("#homeLogo").addClass("transition");
        $("#svgtextgroup").css("transform", "translate(-32px, 0px)");
    }

    $(window).scroll(function (event) {
        $("#animatedLogoSVG:not(.constantAnimated)").addClass("transition");
        $("#animatedLogoSVGText:not(.constantAnimated)").addClass("transition");
        $("#nav-icon").not(".noanimate").addClass("transition");
        $(".desktopNav").not(".noanimate").addClass("transition");
        $("#homeLogo").addClass("transition");

        if ($(".whiteOverlay").length) {
            var scrolltop = $(window).scrollTop();
            var distance = $("#animateSpace").offset().top;
            var height = $("#animateSpace").height();

            var triggerPoint = distance + height;

            if (scrolltop >= triggerPoint) {
                $(".whiteOverlay").addClass("fixed");
            } else {
                $(".whiteOverlay").removeClass("fixed");
            }
        }

        if ($(".whiteOverlayPage").length) {
            var scrolltop = $(window).scrollTop();
            var triggerPoint = $("#animateSpacePage").height();

            if (scrolltop >= triggerPoint) {
                $(".whiteOverlayPage").addClass("fixed");
            } else {
                $(".whiteOverlayPage").removeClass("fixed");
            }
        }

        var scroll = $(window).scrollTop();

        if (scroll > 0) {
            $("#homeLogo").addClass("move");
            $("#animatedLogoSVG").addClass("animated");
            $("#animatedLogoSVGText").addClass("animated");
            $("#svgtextgroup").css("transform", "translate(1px, 0px)");
            $("#svgtextgroup").css("transition", "0.4s ease-in-out");
        } else {
            $("#homeLogo").removeClass("move");
            $("#animatedLogoSVG:not(.constantAnimated)").removeClass("animated");
            $("#animatedLogoSVGText:not(.constantAnimated)").removeClass("animated");
            $("#svgtextgroup").css("transform", "translate(-32px, 0px)");
        }

        if ($(".mobileMenu").hasClass("open")) {
        } else {
            if (scroll > 0) {
                $(".desktopNav").not(".noanimate").addClass("up");
                $("#nav-icon").not(".noanimate").addClass("up");

                // $('.mobileMenu').show();
            } else if (scroll == 0) {
                $("#nav-icon").removeClass("up");
                setTimeout(function () {
                    $(".desktopNav").not(".noanimate").removeClass("up");
                }, 200);
            }
        }
    });

    //reset the open mobile menu state whenever the 992px breakpoint is crossed
    var wasMobile = window.innerWidth < 992;
    $(window).on("resize", function () {
        var isMobile = window.innerWidth < 992;
        if (isMobile === wasMobile) return;
        wasMobile = isMobile;

        $("body").removeClass("hidden");
        $("#page").removeClass("mobileOpen");
        $(".menu .content").removeClass("open").css("display", "");
        $(".menuContainer").removeClass("active");
        $(".menuContainer .menu").removeClass("show");
        $(".mobileMenu, .mobileMenu .contain").removeClass("open");

        $("#Line_971").css("stroke", "#fff");
        $(".ellipseHide").show();
        $("#animatedlogo").css("z-index", "5");
        $("#footer").css("z-index", "101");
        $(".logo svg").removeClass("openNav");
        $("#animatedLogoSVGText").removeClass("openNav");
    });

    //close menu for desktop if resize is bigger than breakpoint
    // $(window).on('resize', function(){
    // 	var win = $(this); //this = window

    // 	if (win.width() > 1200) {

    // 		$('.menu .content.open').hide();

    // 		$('#page').removeClass('mobileOpen');
    // 		$('.menu .content').removeClass('open');
    // 		$('.menuContainer').removeClass('active');
    // 		$('.menuContainer .menu').removeClass('show');

    // 		$('.mobileMenu').removeClass('open');

    // 	}

    // });

    autoPlayYouTubeModal();

    function autoPlayYouTubeModal() {
        var trigger = $(".videoModalTriger");
        trigger.click(function () {
            var theModal = $(this).data("bs-target");
            var videoSRC = $(this).attr("data-videoModal");

            console.log("triggered");

            var videoSRCauto =
                videoSRC +
                "?autoplay=1&mute=0&color=white&controls=0&modestbranding=1&playsinline=1&rel=0&enablejsapi=1";
            $(theModal + " iframe").attr(
                "allow",
                "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            );
            $(theModal + " iframe").attr("src", videoSRCauto);

            $(theModal).on("hidden.bs.modal", function (e) {
                $(theModal + " iframe").attr("src", "");
            });
        });
    }

    $("body").on("click", "#forgotPasswordModal .closeBtn", function (event) {
        event.preventDefault();

        setTimeout(function () {
            $("#auth-password-reset-email").val("");
            $(".ajaxError").empty();
            $(".ajaxSuccess").empty();
        }, 500);
    });

    $("body").on("click", ".lostpassword-button", function (event) {
        event.preventDefault(event);
        const email = $("#auth-password-reset-email").val();
        const action = "authResetPassword";

        $(".ajaxSuccess").empty();

        var has_error = false;

        if (email.length <= 0) {
            // TODO
            has_error = true;
            var error = "The email/username field must not be blank";
        }

        if (has_error == true) {
            // TODO
            $(".ajaxError").html(error);
            return false;
        }

        $.ajax({
            type: "POST",
            url: site_data.adminajax,
            data: {
                action: action,
                email: email,
            },
            dataType: "json",
            encode: true,
        })
            .done(function (response) {
                if (response.status == false) {
                    $(".ajaxError").html(response.message);
                } else {
                    $(".ajaxError").empty();
                    $(".ajaxSuccess").html(response.message);
                    $("#auth-password-reset-email").val("");
                }
            })
            .fail(function () {})
            .always(function () {});

        return false;
    });

    $("body").on("click", ".bookSession", function (event) {
        event.preventDefault();

        var $this = $(this);
        var postID = $this.attr("data-id");

        var index = $this.attr("data-row-index");

        $this.prop("disabled", true);

        // Add a loading icon to the button text
        var originalText = $this.html(); // Save original button content
        $this.html(originalText + ' <span class="spinnerLoading"></span>');

        $.ajax({
            type: "POST",
            url: site_data.adminajax,
            data: {
                action: "registerSession",
                postID: postID,
                index: index,
            },
            dataType: "json",
            encode: true,
            beforeSend: function () {
                console.log(postID);
            },
        })
            .done(function (response) {
                if (response.status == false) {
                    //failed
                    console.log("failed");
                } else {
                    //success
                    location.reload(true);
                }
            })
            .fail(function () {})
            .always(function () {
                //only if page does not reload
                // $this.prop("disabled", false);
                // $this.html(originalText);
            });
    });

    $("body").on("click", ".sessionTab", function (event) {
        event.preventDefault();
        var filter = $(this).attr("data-slug");

        $(".tab").removeClass("active");
        $(this).addClass("active");

        if (filter == "all") {
            $(".sessionRow").fadeOut();
            $(".sessionRow")
                .promise()
                .done(function () {
                    $(".sessionRow").removeClass("show");
                    $(".sessionRow").fadeIn().addClass("show");
                });
        } else {
            $(".sessionRow").fadeOut();
            $(".sessionRow")
                .promise()
                .done(function () {
                    $(".sessionRow").removeClass("show");
                    $(".sessionRow." + filter)
                        .fadeIn()
                        .addClass("show");
                });
        }
    });

    $("body").on("click", ".admin-dashboard-training #complete .session-pagination-container a", function (event) {
        event.preventDefault();

        var url = new URLSearchParams(window.location.search);
        var filter = null;

        if (url.has("filter")) {
            filter = url.get("filter");
        }

        var page = this.children[0].innerText;

        if (page == "") {
            if ($(this).hasClass("next")) {
                page = $(".page-numbers.current>span").text();
                page = parseInt(page) + 1;
            }
            if ($(this).hasClass("prev")) {
                page = $(".page-numbers.current>span").text();
                page = parseInt(page) - 1;
            }
        }

        $.ajax({
            type: "POST",
            url: site_data.adminajax,
            data: {
                action: "session_ajax_pagination",
                nonce: site_data.nonce,
                page: page,
                filter: filter,
            },
            success: function (response) {
                $(".ajax-response").html(response.data.output.rows);
                $(".pagination-ajax").html(response.data.output.pagination);
            },
        });
    });

    $("body").on("change", "#timezoneSelection", function (event) {
        event.preventDefault();

        var timezone = $(this).val();

        $("div.bookedSession .dates").each(function () {
            var datetime = $(this).attr("data-utc");
            var utcTime = moment.utc(datetime, "ddd, DD MMM YYYY HH:mm:ss Z");
            var covertTime = utcTime.tz(timezone);

            var newDay = covertTime.format("dddd Do MMMM YYYY");
            var newTime = covertTime.format("h:mm a z");

            $(this).empty();
            $(this).html("<p>" + newDay + "</p><ul class='sessiontable mb-5'><li>" + newTime + "</li></ul>");
        });

        $("div.conversionDateTime").each(function () {
            var datetime = $(this).attr("data-utc");
            var utcTime = moment.utc(datetime, "ddd, DD MMM YYYY HH:mm:ss Z");
            var covertTime = utcTime.tz(timezone);

            var newDay = covertTime.format("dddd Do MMMM YYYY");
            var newTime = covertTime.format("h:mm a z");

            $(this).empty();
            $(this).html("<p>" + newDay + "</p><ul class='sessiontable'><li>" + newTime + "</li></ul>");
        });

        $("div.modalDateConversion").each(function () {
            var datetime = $(this).attr("data-utc");
            var utcTime = moment.utc(datetime, "ddd, DD MMM YYYY HH:mm:ss Z");
            var covertTime = utcTime.tz(timezone);

            var newDay = covertTime.format("dddd Do MMMM YYYY");
            var newTime = covertTime.format("h:mm a z");

            $(this).empty();
            $(this).html(newDay + "<br>" + newTime);
        });
    });

    //add button to add new exception date field

    $("body").on("click", "[data-tessellate-plus]", function (event) {
        event.preventDefault();
        var count = $("#exception_dates [data-tessellate-plus]").length;
        count++;
        var input =
            '<input placeholder="dd/mm/yy" class="datepicker" type="text" id="date' +
            count +
            '" name="dates[]" value="">';

        var newElement =
            '<div class="d-flex align-items-center justify-content-start mb-2">' +
            input +
            '<span data-tessellate-plus class="icon ms-1 d-flex d-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="17.853" height="17.853" viewBox="0 0 17.853 17.853"><g id="Group_233" data-name="Group 233" transform="translate(1 8.927) rotate(-45)"><line id="Line_105" data-name="Line 105" x2="11.21" y2="11.21" transform="translate(0 0)" fill="none" stroke="#001121" stroke-width="2"/><line id="Line_106" data-name="Line 106" y1="11.21" x2="11.21" transform="translate(0 0)" fill="none" stroke="#001121" stroke-width="2"/></g></svg></span><span data-tessellate-minus class="icon ms-1 d-flex d-flex align-items-center justify-content-center"><svg xmlns="http://www.w3.org/2000/svg" width="17.853" height="17.853" viewBox="0 0 17.853 17.853"><g id="Group_233" data-name="Group 233" transform="translate(1 8.927) rotate(-45)"><line id="Line_105" data-name="Line 105" x2="11.21" y2="11.21" transform="translate(0 0)" fill="none" stroke="#001121" stroke-width="2" /></g></svg></span></div>';

        // $("#exception_dates").append(newElement);

        $(newElement).insertAfter($(this).closest("div"));

        $(".datepicker").datepicker({
            beforeShow: function (input, inst) {
                $("#ui-datepicker-div").addClass("exceptions-datepicker");
            },
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            dateFormat: "dd/mm/yy",
            changeMonth: true,
            changeYear: true,
            yearRange: "-00:+03", // Adjust date format as needed
        });
    });

    $("body").on("click", "[data-tessellate-minus]", function (event) {
        event.preventDefault();
        var prevElement = $(this).parent();
        prevElement.remove();
    });

    //charts
    const chartContainers = document.querySelectorAll(".chart_statistics__container");

    chartContainers.forEach((chart) => {
        const blockID = chart.getAttribute("data-block");

        const chartContainer = chart.querySelector(".chart_statistics__donut-container");
        const chartData = document.getElementById("chart-data-" + blockID);
        const data = JSON.parse(chartData.getAttribute("data-values"));
        const total = chartData.getAttribute("data-total");

        const svg = chart.querySelector("svg.donut");
        let currentOffset = 0;
        let totalDuration = 1000; // Total animation duration (adjustable)
        let accumulatedDelay = 0;
        let hasAnimated = false; // Prevents re-triggering animation

        function animateChart() {
            if (hasAnimated) return;
            hasAnimated = true; // Ensure animation only runs once
            chartContainer.style.opacity = "1"; // Make visible before animation

            data.forEach((item, index) => {
                const percentage = item.value / total;
                const circumference = 251.2; // 2 * PI * r (r=40)
                const strokeDasharray = percentage * circumference;
                const segmentDuration = totalDuration * percentage; // Scale duration based on percentage

                // Create circle segment
                const circle = document.createElementNS("http://www.w3.org/2000/svg", "circle");
                circle.setAttribute("cx", "50");
                circle.setAttribute("cy", "50");
                circle.setAttribute("r", "39");
                circle.setAttribute("fill", "none");
                circle.setAttribute("stroke", item.color);
                circle.setAttribute("stroke-width", "6");
                circle.setAttribute("stroke-dasharray", "0 251.2"); // Start at 0 for animation
                circle.setAttribute("stroke-dashoffset", currentOffset);
                circle.setAttribute("class", "donut-segment");
                circle.style.transition = `stroke-dasharray ${segmentDuration}ms ease-out`;

                svg.appendChild(circle);

                // Animate each segment sequentially with calculated delay
                setTimeout(() => {
                    circle.style.strokeDasharray = `${strokeDasharray} 251.2`;
                }, accumulatedDelay);

                // Update the offset and accumulated delay for the next segment
                currentOffset -= strokeDasharray;
                accumulatedDelay += segmentDuration; // Delay increases based on segment size
            });
        }

        // Setup Intersection Observer to trigger animation when in view
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        animateChart();
                        observer.disconnect(); // Stop observing once animated
                    }
                });
            },
            { threshold: 0.7 },
        );

        observer.observe(chartContainer);
    });

    const container = document.querySelector(".quantity");
    if (container) {
        const input = container.querySelector("input");
        container.querySelector(".increment").addEventListener("click", () => {
            input.focus();
            input.value = parseInt(input.value || 0) + 1;
            input.blur();
        });
        container.querySelector(".decrement").addEventListener("click", () => {
            input.focus();
            input.value = parseInt(input.value || 0) - 1;
            input.blur();
        });
    }
});

["comparison_filter1", "comparison_filter2"].forEach(function (id) {
    document.addEventListener("DOMContentLoaded", function () {
        const el = document.getElementById(id);

        if (!el) return;

        el.addEventListener("change", function () {
            const col = el.getAttribute("data-col");
            const qid = el.options[el.selectedIndex].getAttribute("data-qid");
            const truevalue = el.options[el.selectedIndex].getAttribute("data-value");

            let value = "";
            let label = "";

            if (truevalue) {
                value = truevalue;
                label = this.value;
            } else {
                value = this.value;
            }

            const compare_data = new FormData();
            compare_data.append("action", "compare_data_ajax");
            compare_data.append("value", value);
            compare_data.append("label", label);

            if (qid) {
                compare_data.append("qid", qid);
            }

            if (value == "") {
                value = "All Participants";
            }

            fetch(site_data.adminajax, {
                method: "POST",
                body: compare_data,
            })
                .then((response) => response.json())
                .then((data) => {
                    const count = data.data.count;

                    const heading = "ajax-heading" + col;
                    const results = data.data.section1;
                    const ajaxClass = "section1-ajax" + col;
                    document
                        .querySelectorAll(`.${heading}`)
                        .forEach((el) => (el.innerHTML = `${label || value} <span>${count}</span>`));

                    Object.keys(results).forEach((label) => {
                        const cell = document.querySelector(`.${ajaxClass}[data-row="${label}"]`);
                        if (cell) cell.innerHTML = results[label].data1;
                    });

                    const results2 = data.data.section2;
                    const ajaxClass2 = "section2-ajax" + col;
                    Object.keys(results2).forEach((label) => {
                        const cell2 = document.querySelector(`.${ajaxClass2}[data-row="${label}"]`);
                        if (cell2) cell2.innerHTML = results2[label].data1;
                    });

                    const results3 = data.data.section3;
                    const ajaxClass3 = "section3-ajax" + col;
                    Object.keys(results3).forEach((label) => {
                        const cell3 = document.querySelector(`.${ajaxClass3}[data-row="${label}"]`);
                        if (cell3) cell3.innerHTML = results3[label].data1;
                    });

                    const results4 = data.data.section4;
                    Object.keys(results4).forEach((label) => {
                        const cellBefore = document.querySelector(`.section4-ajax${col}-before[data-row="${label}"]`);
                        const cellAfter = document.querySelector(`.section4-ajax${col}-after[data-row="${label}"]`);
                        if (cellBefore) cellBefore.innerHTML = results4[label].data1_before;
                        if (cellAfter) cellAfter.innerHTML = results4[label].data1_after;
                    });

                    const results5 = data.data.section5;
                    const ajaxClass5 = "section5-ajax" + col;
                    Object.keys(results5).forEach((label) => {
                        const cell5 = document.querySelector(`.${ajaxClass5}[data-row="${label}"]`);
                        if (cell5) cell5.innerHTML = results5[label].data1;
                    });
                })
                .catch((err) => {
                    console.error("compare data error:", err);
                });
        });
    });
});
